import { reactive, onMounted, onBeforeUnmount } from "vue";

export function useResize(el) {
	const size = reactive({ height: null, width: null });
	const robs = new ResizeObserver(() => {
		size.height = el.value.clientHeight;
		size.width = el.value.clientWidth;
	});

	onMounted(() => {
		size.height = el.value.clientHeight;
		size.width = el.value.clientWidth;

		robs.observe(el.value);
	});

	onBeforeUnmount(() => {
		robs.unobserve(el.value);
	});

	return size;
}
